<template>
  <router-link v-bind="$attrs" :to="localTo">
    <slot />
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const LANG_PREFIX_REGEX = /^\/(en|fr|es|ar)(\/|$)/;

const props = defineProps({
  to: {
    type: [String, Object],
    required: true
  }
});

const route = useRoute();

const localTo = computed(() => {
  const lang = route.params.lang || 'en';

  if (typeof props.to === 'string') {
    // Already has a lang prefix — pass through
    if (LANG_PREFIX_REGEX.test(props.to)) return props.to;

    const path = props.to.startsWith('/') ? props.to : `/${props.to}`;
    return `/${lang}${path}`;
  }

  // Route object with name — named routes resolve correctly via children
  if (props.to.name) {
    return { ...props.to, params: { lang, ...props.to.params } };
  }

  // Route object with path
  if (props.to.path) {
    if (LANG_PREFIX_REGEX.test(props.to.path)) return props.to;
    const path = props.to.path.startsWith('/') ? props.to.path : `/${props.to.path}`;
    return { ...props.to, path: `/${lang}${path}` };
  }

  return props.to;
});
</script>
